'use client';

import { c as _c } from "react/compiler-runtime";
import dynamic from 'next/dynamic';
type HeaderLoginModalProps = {
  isOpen: boolean;
  onClose: () => void;
};
const LoginModal = dynamic(() => import('src/features/auth-modal/login-modal').then(mod => mod.LoginModal), {
  ssr: false
});
export function HeaderLoginModal(t0) {
  const $ = _c(3);
  const {
    isOpen,
    onClose
  } = t0;
  let t1;
  if ($[0] !== isOpen || $[1] !== onClose) {
    t1 = <LoginModal isOpen={isOpen} onClose={onClose} />;
    $[0] = isOpen;
    $[1] = onClose;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}